import * as logger from 'logger';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import App from 'pages/app';
// import register from 'service-worker/registerServiceWorker';
import update from 'immutability-helper';
import { auto, autoArray } from 'helpers/immutability-helper';
import { BrowserRouter } from 'react-router-dom';
import { ConnectedRouter } from 'react-router-redux';
import { history, store } from 'pages/app/store';
import { Provider } from 'react-redux';
import 'semantic-ui-offline/semantic.min.css';

const fetchMock = require('fetch-mock-es5');

if (fetchMock === undefined) {
  console.log('no fetchMock!');
} else {
  fetchMock.config.fallbackToNetwork = true;
  // tslint:disable-next-line:no-string-literal
  window['fetchMock'] = fetchMock;
}

update.extend('$auto', auto);
update.extend('$autoArray', autoArray);

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ConnectedRouter>
  </Provider>,
  document.getElementById('root') as HTMLElement
);

logger.init();



// WEBPACK FOOTER //
// ./src/index.tsx